// タブ
const tabList = document.querySelectorAll('.js-tab-trigger');
// タブコンテンツ
const tabContent = document.querySelectorAll('.p-access__contents');
 
//DOMが読み込み終わったら
document.addEventListener('DOMContentLoaded', function(){
  // タブに対してクリックイベントを適用
  for(let i = 0; i < tabList.length; i++) {
    tabList[i].addEventListener('click', tabSwitch);
  }
  // タブをクリックすると実行する関数
  function tabSwitch(){
    // activeクラスを削除
    document.querySelectorAll('.active')[0].classList.remove('active');
    // クリックしたタブにactiveクラスを付与
    this.classList.add('active');
    // showクラスを削除
    document.querySelectorAll('.is-show')[0].classList.remove('is-show');
    // タブを配列風オブジェクトとして定義
    const aryTabs = Array.prototype.slice.call(tabList);
    // クリックしたタブの配列番号を取得
    const index = aryTabs.indexOf(this);
    // クリックしたタブと同じ配列番号のタブコンテンツにshowクラスを付与    
    tabContent[index].classList.add('is-show');
  };
});



// 別ページからタブを開いてタブ内の要素へアンカー遷移
document.addEventListener('DOMContentLoaded', function () {
  // URLからタブ情報を取得
  const urlParams = new URLSearchParams(window.location.search);
  const tabParam = urlParams.get('tab');

  // タブ要素とパネル要素を取得（駐車場）
  const tabParking = document.getElementById('tab-parking');
  const parking = document.getElementById('parking');

  // タブを開く関数
  function openTab(tabId) {
    if (tabId === 'tab-parking') {
      // classを削除して、tabParkingにだけclass付与
      document.querySelectorAll('.active')[0].classList.remove('active');
      tabParking.classList.add('active');
      // classを削除して、parkingにだけclass付与
      document.querySelectorAll('.is-show')[0].classList.remove('is-show');
      parking.classList.add('is-show');
    }
  }

  // URLパラメータから取得したタブ情報に基づいてタブを開く
  if (tabParam === 'tab-parking') {
    openTab('tab-parking');
  }

  // 他のページのエラー回避
  if (!tabParking) {
    return false;
  }
  // タブが開かれたら、指定の要素にアンカー遷移
  tabParking.addEventListener('change', () => {
    if (tabParking.classList.add('active')) {
      parking.scrollIntoView({ behavior: 'smooth' });
    }
  });
});